
import * as ACTIONS from '../../constants';

export const  loginUserAction = (values) => {
    return {
		type: ACTIONS.LOGIN_CRYODEX,
		payload: values
    }
  };
   
export const  registerUserAction = (values) => {
    return {
		type: ACTIONS.REGISTER_CRYODEX,
		payload: values
    }
};

export function updateCountries(payload) {
	return { 
		type: ACTIONS.CRYODEX_UPDATE_COUNTRIES, payload 
	};
}

export function updateCities(payload) {
	return { 
		type: ACTIONS.CRYODEX_UPDATE_CITIES, payload 
	};
}

export const  resetPasswordAction = (value) => {
    return {
		type: ACTIONS.RESET_PASSWORD_CRYODEX,
		payload: value
    }
};

